// extracted by mini-css-extract-plugin
export default {"image_zoom_container":"Images_image_zoom_container__Yxqzr","first_image":"Images_first_image__eACgi"};